import Actions              from 'Redux/Actions';
import { AppUserRepository } from 'Domain/Repositories';
import { ofType }           from 'redux-observable';
import { from }             from 'rxjs';
import { mergeMap }         from 'rxjs/operators';
import { TEpic }            from 'Redux/Config';

export const removeAppUserOrganisationEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.removeAppUserOrganisationRequest.type),
    mergeMap(action => from(
      AppUserRepository.removeAppUserFromOrganisation({ appUserId: action.payload.userId, organisationId: action.payload.organisationId })
        .then(() => Actions.removeAppUserOrganisationSuccess({ organisationId: action.payload.organisationId }))
        .catch((error: Error) => Actions.removeAppUserOrganisationFailure({ error })),
    )),
  );
};
